import React from "react";
import { Device } from "../../../types/Device";
import { DirectionalCount } from "../../../types/Count";
import { Card, CardHeader } from "@mui/material";
import { DeviceImage } from "./device-image";

export interface DeviceCardProps {
    device: Device;
    count: DirectionalCount;
    videoId?: string;
    renderContent: (props: DeviceCardProps) => React.ReactNode;
    getDeviceType: (
        props: DeviceCardProps,
    ) => "unidirectional" | "bidirectional" | "viewOnly";
}

export const BaseDeviceCard: React.FC<DeviceCardProps> = (props) => {
    const { device, videoId, renderContent } = props;

    return (
        <Card sx={{ objectFit: "contain", maxHeight: 380 }}>
            <CardHeader
                title={device.displayName}
                sx={{ textAlign: "center" }}
            />
            <DeviceImage title={device.displayName} videoId={videoId} />
            {renderContent(props)}
        </Card>
    );
};
